module.exports = __webpack_public_path__ + "img/5ecf69f6435a0d4fb44f85a754ee787c.5ecf69f6.png";